import { Permission } from '../../enums';
import { MenuItem } from '../../interfaces';

export const menuItems: MenuItem[] = [
    {
        title: 'Home',
        icon: 'home',
        link: '/home',
        // permissions: [Permission.Home],
    },
    {
      title: 'Cards',
      icon: 'card-icon-sidemenu',
      link: 'cards-listing',
    //   permissions: [Permission.Home],
    },
    {
      title: 'Transactions',
      icon: 'transaction',
      link: 'transaction',
    //   permissions: [Permission.Home],
    },
];
